import { Navigate } from 'react-router-dom';

/*
  NOTE - This was orignally intended to be a very high-level
  dashboard for a quick view of alarms/tickets/whatever. It
  currently just directs to the alarms view but I've left
  it in place in case we get to a point where we can make
  something compelling here.
*/

function Dashboard() {
  return (
    <>
      <Navigate to="/alarms" replace={true} />
    </>
  )
}

export default Dashboard;
